import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactFlagsSelect from 'react-flags-select';

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  // Map country codes (used by react-flags-select) to language codes (used by i18next)
  const countryToLanguageMap = {
    US: 'en',
    FR: 'fr',
    ES: 'es',
    DE: 'de',
    IT: 'it',
  };

  // Convert current i18next language to corresponding country code for initial selection
  const getInitialCountryCode = () => {
    return (
      Object.keys(countryToLanguageMap).find(
        (key) => countryToLanguageMap[key] === i18n.language
      ) || 'US'
    );
  };

  const [selected, setSelected] = React.useState(getInitialCountryCode);

  return (
    <div>
      <ReactFlagsSelect
        selected={selected}
        onSelect={(code) => {
          setSelected(code);
          const language = countryToLanguageMap[code];
          i18n.changeLanguage(language); // Update i18next language
        }}
        showSelectedLabel={false}
        showOptionLabel={false}
        selectedSize={16}
        optionsSize={16}
        countries={['US', 'ES']}
      />
    </div>
  );
};

export default LanguageSelector;